import axiosInstance from './axios';

const BASE_URL = '/admin';

const adminService = {
  // Users
  getUsers: async () => {
    const response = await axiosInstance.get(`${BASE_URL}/users`);
    return response.data;
  },

  getUserById: async (userId) => {
    const response = await axiosInstance.get(`${BASE_URL}/users/${userId}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await axiosInstance.post(`${BASE_URL}/users`, userData);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await axiosInstance.delete(`${BASE_URL}/users/${userId}`);
    return response.data;
  },

  // Roles
  getUserRoles: async (userId) => {
    const response = await axiosInstance.get(`${BASE_URL}/users/${userId}/roles`);
    return response.data;
  },

  assignRoleToUser: async (userId, roleName) => {
    const response = await axiosInstance.post(`${BASE_URL}/users/${userId}/roles`, { roleName });
    return response.data;
  },

  removeRoleFromUser: async (userId, roleName) => {
    const response = await axiosInstance.delete(`${BASE_URL}/users/${userId}/roles/${roleName}`);
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await axiosInstance.put(`${BASE_URL}/users/${userId}`, userData);
    return response.data;
  },

  getAllRoles: async () => {
    const response = await axiosInstance.get(`${BASE_URL}/roles`);
    return response.data;
  },
};

export default adminService;
